var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.64 179.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:20.51px;font-family:Lato-BlackItalic, Lato;font-weight:800;font-style:italic;}.cls-3{letter-spacing:-0.02em;}.cls-4{font-family:Lato-Regular, Lato;font-weight:400;}.cls-4,.cls-6{font-style:normal;}.cls-5{letter-spacing:-0.03em;}.cls-6{font-family:Lato-Light, Lato;font-weight:300;}.cls-7{letter-spacing:-0.02em;}.cls-10,.cls-8,.cls-9{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.91px;}.cls-9{stroke-dasharray:10.68 10.68;}.cls-10{stroke-dasharray:10.85 10.85;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.92,52.22a38.16,38.16,0,0,1-3-8.17,35.52,35.52,0,0,1-1-8.16,36.83,36.83,0,0,1,5.46-19Q10.91,7.67,21.57,0l7.08,4.5a2.91,2.91,0,0,1,1.17,1.21,3.51,3.51,0,0,1,.41,1.62,3.47,3.47,0,0,1-.58,2q-.58.83-1.83,2.25c-.5.61-1.16,1.45-2,2.54A23.13,23.13,0,0,0,23.57,18a30.31,30.31,0,0,0-1.87,5.08,22.4,22.4,0,0,0-.8,6.08,24.37,24.37,0,0,0,.63,5.37,29.4,29.4,0,0,0,2,5.87A3.54,3.54,0,0,1,23.9,42a4,4,0,0,1-1.16,2.75,7.6,7.6,0,0,1-3.17,1.92Zm28,0a38.16,38.16,0,0,1-3-8.17,35.52,35.52,0,0,1-1-8.16,36.83,36.83,0,0,1,5.46-19Q38.89,7.67,49.55,0l7.08,4.5A2.91,2.91,0,0,1,57.8,5.71a3.51,3.51,0,0,1,.41,1.62,3.39,3.39,0,0,1-.58,2q-.59.83-1.83,2.25c-.5.61-1.15,1.45-2,2.54A23.13,23.13,0,0,0,51.55,18a30.31,30.31,0,0,0-1.87,5.08,22.4,22.4,0,0,0-.79,6.08,24.34,24.34,0,0,0,.62,5.37,29.4,29.4,0,0,0,2,5.87A3.54,3.54,0,0,1,51.88,42a3.93,3.93,0,0,1-1.16,2.75,7.53,7.53,0,0,1-3.17,1.92Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(89.34 40.14)"
  }, "&quot;El p", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 39.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.79,
    y: 0
  }, "oceso de donaci\xF3n es muy sencillo y "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22.98
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 7.49,
    y: 22.98
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.77,
    y: 22.98
  }, "anspa"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 66.96,
    y: 22.98
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.24,
    y: 22.98
  }, "ente. Lo "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 146.03,
    y: 22.98
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.32,
    y: 22.98
  }, "ecomiendo ampliamente.&quot;"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 91.9
  }, "Luisa "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 50.46,
    y: 91.9
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.36,
    y: 91.9
  }, "ern\xE1ndez")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 114.88
  }, "Donado"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 70.06,
    y: 114.88
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.7,
    y: 114.88
  }, "a recurrente"))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "496.19 173.86 496.19 179.29 490.75 179.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 480.07,
    y1: 179.29,
    x2: 79.45,
    y2: 179.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "74.11 179.29 68.67 179.29 68.67 173.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 68.67,
    y1: 163.01,
    x2: 68.67,
    y2: 16.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "68.67 11.18 68.67 5.74 74.11 5.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 84.79,
    y1: 5.74,
    x2: 485.41,
    y2: 5.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "490.75 5.74 496.19 5.74 496.19 11.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 496.19,
    y1: 22.03,
    x2: 496.19,
    y2: 168.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial3);
export default __webpack_public_path__ + "static/media/testimonial3.21a7a2ffcbffd1219924866137facc79.svg";
export { ForwardRef as ReactComponent };